import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { OK } from '../../theme/palette.js';

/**
 * Our own wordmark.
 *
 * Deliberately NOT the Oklahoma state seal or the star device - those are
 * official marks of the State of Oklahoma and this is not a state application.
 * The five-bar motif borrows only the palette, which is free to use.
 */
export default function Wordmark() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
      <Box
        aria-hidden="true"
        sx={{ display: 'flex', gap: '3px', alignItems: 'flex-end', height: 22 }}
      >
        {[
          { c: OK.stateBlue, h: 14 },
          { c: OK.green, h: 20 },
          { c: OK.gold, h: 11 },
          { c: OK.red, h: 17 },
          { c: OK.darkBlue, h: 22 },
        ].map((bar, i) => (
          <Box
            key={i}
            sx={{ width: 4, height: bar.h, bgcolor: bar.c, borderRadius: '1px' }}
          />
        ))}
      </Box>

      <Typography
        variant="h1"
        noWrap
        sx={{ fontSize: '1.0625rem', fontWeight: 700, letterSpacing: '-0.02em' }}
      >
        Oklahoma Geospatial Data
      </Typography>
    </Box>
  );
}
